const FAQ_ITEMS = [
  {
    q: '黑料每日大赛是什么网站？',
    a: '黑料每日大赛是一个娱乐资讯聚合平台，每日更新全网最新爆料、吃瓜事件与黑料合集。我们汇聚娱乐圈、网红圈、社会热点等多个领域的精彩内容，让你一站式吃遍全网热门黑料，是全网最活跃的吃瓜社区。',
  },
  {
    q: '网站内容每日几点更新？',
    a: '我们保持全天候滚动更新，每日早上8点、中午12点、晚上8点三个时段集中推送最新黑料。突发重大爆料会即时更新，确保你不会错过任何一口热瓜。黑料每日速递让你随时掌握最新动态。',
  },
  {
    q: '如何向网站投稿爆料？',
    a: '欢迎通过页面下方的联系投稿入口向我们提供线索。你的投稿将经过编辑团队核实后发布，我们承诺严格保护投稿人隐私，匿名爆料同样欢迎。优质爆料一经采纳还有机会获得奖励。',
  },
  {
    q: '网站内容是否真实可靠？',
    a: '我们的编辑团队会对每一条爆料进行多方交叉验证，标注信息来源与可信度等级。对于未经证实的传闻，我们会明确标注"传闻"标签。黑料每日大赛坚持传播真实信息，拒绝恶意造谣。所有内容仅供娱乐参考。',
  },
  {
    q: '如何查看往期内容和历史黑料？',
    a: '你可以通过首页的主题索引按分类浏览往期内容，也可以使用话题标签筛选感兴趣的主题。黑料排行榜展示了历史热度最高的爆料，吃瓜合集则按时间线汇总每日精彩内容，方便你回顾。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于黑料每日大赛，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {FAQ_ITEMS.map((item, idx) => (
            <details key={idx} className="group rounded-lg bg-background-50 border border-background-200/60 overflow-hidden">
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <h3 className="font-medium text-sm md:text-base text-foreground-800 pr-4">
                  {item.q}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center shrink-0 text-foreground-500 group-open:rotate-45 transition-transform">
                  <i className="ri-add-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}